module.exports = __webpack_public_path__ + "static/media/service_system_9.1b17d3bc.png";